import { subdomain } from "utils";

export default {
  fontFamily: subdomain() === "sprift" ? "Avenir" : "Basier Circle",
};
